
import React from 'react';
import { CategoryType } from './types';

export const CATEGORY_CONFIG: Record<CategoryType, { icon: React.ReactElement, color: string }> = {
  'Salário': { icon: <i className="fa-solid fa-money-bill-trend-up"></i>, color: 'bg-emerald-500' },
  'Renda Extra': { icon: <i className="fa-solid fa-hand-holding-dollar"></i>, color: 'bg-teal-500' },
  'Cartão de Crédito': { icon: <i className="fa-solid fa-credit-card"></i>, color: 'bg-blue-500' },
  'Compra Parcelada': { icon: <i className="fa-solid fa-layer-group"></i>, color: 'bg-indigo-500' },
  'Pagamento de Fatura': { icon: <i className="fa-solid fa-file-invoice-dollar"></i>, color: 'bg-indigo-400' },
  'Investimento': { icon: <i className="fa-solid fa-chart-line"></i>, color: 'bg-cyan-500' },
  'Pagamento fixo/mês': { icon: <i className="fa-solid fa-calendar-check"></i>, color: 'bg-violet-500' },
  'Moradia': { icon: <i className="fa-solid fa-house-chimney"></i>, color: 'bg-indigo-500' },
  'Pessoal': { icon: <i className="fa-solid fa-user-tie"></i>, color: 'bg-pink-500' },
  'Desenvolvimento': { icon: <i className="fa-solid fa-graduation-cap"></i>, color: 'bg-orange-500' },
  'Transporte': { icon: <i className="fa-solid fa-car"></i>, color: 'bg-slate-500' },
  'Entretenimento': { icon: <i className="fa-solid fa-clapperboard"></i>, color: 'bg-purple-600' },
  'Pets': { icon: <i className="fa-solid fa-paw"></i>, color: 'bg-amber-500' },
  'Final de semana': { icon: <i className="fa-solid fa-martini-glass-citrus"></i>, color: 'bg-rose-500' },
  'Delivery': { icon: <i className="fa-solid fa-motorcycle"></i>, color: 'bg-orange-600' },
  'Outros': { icon: <i className="fa-solid fa-ellipsis"></i>, color: 'bg-gray-400' },
};
